export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7448.5ae81a0b.jpg";